import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Wrap = styled.main`
  padding: 40px 0;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-top: 20px;
`;

const Card = styled(Link)`
  border: 1px solid var(--bdr);
  border-radius: 16px;
  background: var(--card);
  box-shadow: var(--shadow);
  overflow: hidden;
  text-decoration: none;
  color: inherit;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.15);
  }
`;

const CardImage = styled.div`
  width: 100%;
  height: 200px;
  background: #f5f5f5;
  background-image: url(${props => props.src});
  background-size: cover;
  background-position: center;
`;

const CardContent = styled.div`
  padding: 20px;
  
  h3 {
    margin: 0 0 8px;
    font-size: 18px;
    font-weight: 700;
  }
  
  .price {
    font-size: 20px;
    font-weight: 900;
    color: var(--primary);
    margin: 8px 0;
  }
  
  .details {
    color: var(--muted);
    font-size: 14px;
    margin: 8px 0;
  }
  
  .badges {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    margin-top: 12px;
  }
  
  .badge {
    padding: 4px 8px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    background: var(--primary);
    color: var(--primaryFg);
  }
`;

const testObjects = [
  {
    id: 1,
    slug: 'elite-apartment-center',
    title: 'Элитная квартира в центре',
    price: '5,000,000 AED',
    image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=400&h=300&fit=crop',
    details: '2-3 спальни • 80-120 м² • Центральный район',
    badges: ['В продаже', 'Рассрочка', 'Рекомендуемый']
  },
  {
    id: 2,
    slug: 'penthouse-sea-view',
    title: 'Пентхаус с видом на море',
    price: '8,000,000 AED',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=400&h=300&fit=crop',
    details: '3-4 спальни • 200-300 м² • Дубай Марина',
    badges: ['В продаже', 'Инвестиционный', 'Рекомендуемый']
  },
  {
    id: 3,
    slug: 'investment-apartment-dubai',
    title: 'Инвестиционная квартира в Дубае',
    price: '3,500,000 AED',
    image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=400&h=300&fit=crop',
    details: '1-2 спальни • 100-120 м² • Business Bay',
    badges: ['В продаже', 'Инвестиционный']
  },
  {
    id: 4,
    slug: 'studio-investment',
    title: 'Студия для инвестиций',
    price: '1,800,000 AED',
    image: 'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=400&h=300&fit=crop',
    details: 'Студия • 50 м² • JVC',
    badges: ['В продаже', 'Инвестиционный']
  }
];

export default function TestObjects() {
  return (
    <Wrap className="container">
      <h1>Тестовые объекты недвижимости</h1>
      <p>Выберите объект для просмотра обновленной карточки с новыми компонентами:</p>
      
      <Grid>
        {testObjects.map(obj => (
          <Card key={obj.id} to={`/realty/${obj.slug}`}>
            <CardImage src={obj.image} />
            <CardContent>
              <h3>{obj.title}</h3>
              <div className="price">{obj.price}</div>
              <div className="details">{obj.details}</div>
              <div className="badges">
                {obj.badges.map((badge, index) => (
                  <span key={index} className="badge">{badge}</span>
                ))}
              </div>
            </CardContent>
          </Card>
        ))}
      </Grid>
      
      <div style={{ marginTop: '40px', padding: '20px', background: 'var(--card)', borderRadius: '16px', border: '1px solid var(--bdr)' }}>
        <h3>Что нового в карточках объектов:</h3>
        <ul>
          <li><strong>Новый слайдер визуализаций</strong> - после описания объекта с золотыми плашками</li>
          <li><strong>Удобства с фото</strong> - сетка карточек с изображениями и описаниями</li>
          <li><strong>Расширенная информация о локации</strong> - 3 категории ближайших мест</li>
          <li><strong>Адаптивный дизайн</strong> - оптимизировано для всех устройств</li>
        </ul>
      </div>
    </Wrap>
  );
}